import React, { FC } from 'react'
import { MapLayerMenu } from './components/MapLayerMenu'
import { MapStylesMenu } from './components/MapStylesMenu'
import { MobilityMenu } from './components/MobilityMenu'
import styles from './VisualizationTools.module.scss'
//import { useFetchOrganization } from 'services/organization'

type VisualizationToolsProps = {
  onLightMapClick: any
  onDarkMapClick: any
  onSatelliteMapClick: any
  onStreetMapClick: any
  saveClipped: any
  project: any
  projectId: string
}

export const VisualizationTools: FC<VisualizationToolsProps> = ({
  onLightMapClick,
  onDarkMapClick,
  onSatelliteMapClick,
  onStreetMapClick,
  saveClipped,
  project,
  projectId,
}) => {
  //const { organization } = useFetchOrganization()
  //const [mobilityAvailable, setMobilityAvailable] = React.useState<boolean | undefined>(undefined)
  //const orgId = organization?.id
  //const organizations = [157, 9, 161, 662, 664, 663, 665, 671, 672, 484]

  /*React.useEffect(() => {
    if (orgId !== undefined) {
      organizations.includes(orgId) ? setMobilityAvailable(true) : setMobilityAvailable(false)
    } else {
      setMobilityAvailable(undefined)
    }
  }, [orgId, organizations])*/

  return (
    <div className={styles.visualizationTools}>
      {projectId && (
        <React.Fragment>
          {<MobilityMenu projectId={projectId} />}
        </React.Fragment>
      )}
      <MapStylesMenu
        onLightMapClick={onLightMapClick}
        onDarkMapClick={onDarkMapClick}
        onSatelliteMapClick={onSatelliteMapClick}
        onStreetMapClick={onStreetMapClick}
      />
      {<MapLayerMenu saveClipped={saveClipped} project={project} />}
    </div>
  )
}

VisualizationTools.displayName = 'VisualizationTools'
